import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import type { ControllerRenderProps } from 'react-hook-form'
import type { ComboboxItems } from '@/components/inputs/combobox'
import type { MatchCoursesFormType } from '@/schemas/education/match-courses-schema'
import { getAllAvailableCourses } from '@/services/education/get-all-available-courses'

export const useStudentTransferDesiredCourseStep = () => {
  const [coursesOptions, setCoursesOptions] = useState<ComboboxItems[]>([])

  const { data, isLoading } = useQuery({
    queryKey: ['fddfdf'],
    queryFn: getAllAvailableCourses
  })

  useEffect(() => {
    if (data) {
      const options: ComboboxItems[] = data.map((course) => ({
        data: course,
        value: course.id,
        label: course.name
      }))

      setCoursesOptions(options)
    }
  }, [data])

  function handleDesiredCourseSelect(
    field: ControllerRenderProps<MatchCoursesFormType, 'desiredEducation'>,
    value: ComboboxItems
  ) {
    field.onChange({
      desiredEducationId: value.value,
      desiredEducationName: value.label
    })
  }

  return {
    states: {
      coursesOptions,
      isLoading
    },
    actions: {
      handleDesiredCourseSelect
    }
  }
}
